export default "__VITE_ASSET__DBiHpwTs__"